import { Timesheet } from "domain/entities/timesheet";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface TimesheetState {
  timesheet: Timesheet | null;
  setTimesheet: (newTimesheet: Partial<Timesheet>) => void;
  resetTimesheet: () => void;
}

const initialTimesheetState: Timesheet = {
  id: "",
  employee: { id: "", name: "" },
  month: 0,
  year: 0,
  version: 0,
  status: "Novo",
  createdAt: new Date(),
  modifiedAt: new Date(),
  lastModifiedBy: ""
};

export const useTimesheetStore = create<TimesheetState>()(
  devtools(
    (set) => ({
      timesheet: initialTimesheetState,
      setTimesheet: (newTimesheet) =>
        set((state) => ({
          timesheet: { ...state.timesheet, ...newTimesheet } as Timesheet,
        })),
      resetTimesheet: () => set({ timesheet: initialTimesheetState }),
    }),
    { name: "TimesheetSelected" }
  )
);
